import React, { useRef, useEffect } from 'react';

import { Grid } from '@mui/material';

import HotelCardMap from '../../../SharedHotelCardContent/HotelCardMap';

import defaultImage from '@shared/assets/slides-noImg/no-hotel1.png';

import { sxStyle } from './styles';

const MapModal = ({
  hotel,
  getFavConfig,
  viewFullWidhtMap,
  handleCloseModal,
  handleChangePage,
  hasIdFav,
  isLoadImage,
  setIsLoadImage,
}) => {
  const retryTimeoutRef = useRef(null);
  const retryCountRef = useRef(0);

  const handleImageError = (e, main_image) => {
    e.target.src = defaultImage;

    if (retryCountRef.current < 18) {
      retryTimeoutRef.current = setTimeout(() => {
        retryCountRef.current += 1;
        e.target.src = main_image;
      }, 1500);
    } else {
      e.target.onerror = null;
    }
  };

  useEffect(() => {
    return () => {
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
    };
  }, []);

  return (
    <Grid
      container
      direction="column"
      spacing={2}
      sx={
        viewFullWidhtMap
          ? sxStyle.modalHotelMapFullWidth
          : sxStyle.modalHotelMap
      }
      id="CardModal"
    >
      <HotelCardMap
        hotel={hotel}
        hasIdFav={hasIdFav}
        isLoadImage={isLoadImage}
        setIsLoadImage={setIsLoadImage}
        getFavConfig={getFavConfig}
        handleImageError={handleImageError}
        defaultImage={defaultImage}
        handleChangePage={handleChangePage}
        compare={false}
        isFromMap={true}
        handleCloseModal={handleCloseModal}
      />
    </Grid>
  );
};

export default MapModal;
